/**
 * Centralized border radius definitions for the Outschool design system.
 *
 * Based on the border radius guidelines from the design system documentation.
 */

export const borderRadius = {
  /** Minimal rounding - 4px - Used for: chips (to distinguish from pill-shaped buttons) */
  tiny: "4px",
  /** Small rounding - 8px - Used for: form elements, alerts, tooltips, text fields, dropdowns */
  small: "8px",
  /** Medium rounding - 16px - Used for: cards, containers, modals */
  medium: "16px",
  /** Large rounding - 24px - Used for: prominent surfaces, large containers */
  large: "24px",
  /** Pill shape - 999px - Used for: buttons, search box (fully rounded ends) */
  pill: "999px",
  /** Circle - 50% - Used for: slider thumbs, avatars, icon buttons, badges (perfect circles) */
  circle: "50%",
} as const;

export type BorderRadiusKey = keyof typeof borderRadius;
